<template>
<div  class="container-fluid">

 <img v-show="false" id="barcode"/>
 
  <div class="card border-success">
  <div  class="card-header text-white bg-primary">
    <h4> <i style="color:yellow" class="fas fa-list-ol mr-2" aria-hidden="true"></i>LISTA OPERAZIONI DI VENDITA/PAGAMENTI</h4>   
  </div>

  <div  class="card-body"> 
 
   <div class="row">
   <div v-if="items.length==0 && payments.length == 0" class="col-md-4"> 

   <div class="card border-info" >
   <div class="card-header bg-info">
    <i style="color:yellow" class="fas fa-stream mr-2" aria-hidden="true"></i>
    <strong>PARAMETRI DI RICERCA</strong></div>
   <div class="card-body text-dark">

  <!--<form name="searchPayment" v-on:submit.prevent="option==1 ? getSalesList($event) : getPaymentsList($event)">-->


          <label class="" for="data"><strong>da Data vendita </strong></label>      
          <input :disabled="isAdmin==0 && company.Id==28" type="date"  class="form-control " id="create_at1"  v-model="create_at_from">

          <label class="" for="data"><strong>a Data vendita </strong></label>      
          <input :disabled="isAdmin==0 && company.Id==28" type="date"  class="form-control " id="create_at2"  v-model="create_at_to">
          
          <div class="form-group">
    
            <store-select v-bind:props="store"  @update="setStoreId"></store-select> 
    
          </div>


        <cassa class="mt-2" @setDesk="setDesk"/>

        <div class="form-check mt-3">
          <input class="form-check-input" type="radio" name="exampleRadios1" id="exampleRadios1" value="1" v-model="option"  >
          <label class="form-check-label" for="exampleRadios1">
            VENDITE
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="radio" name="exampleRadios2" id="exampleRadios2" value="2" v-model="option" >
          <label class="form-check-label" for="exampleRadios2">
            PAGAMENTI
          </label>
        </div>
<!--
        <span><strong>Provenienza vendita</strong></span>
        <div  v-for="(item,index) in salesFrom" :key="index">  
              <div class="form-check">
                <input type="radio" class="form-check-input" :id="'typeId_' + index" :value="index" v-model="typeId">
                <label class="form-check-label"  :for="'typeId_' + index">{{item.description}}</label>
              </div>
        </div> 
      -->


<div class="card-footer mt-3 bg-transparent border-info"> 
  <alert-box  @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
  <button @click="option==1 ? getSalesList($event) : getPaymentsList($event)" :disabled="bt_spinner" class="btn btn-primary active float-right">
    <i  class="fas fa-binoculars mr-2" aria-hidden="true"></i>
    CERCA
    <span v-if="bt_spinner"  class="spinner-border spinner-border-sm ml-3 text-warning" role="status" aria-hidden="true"></span>
  </button>
</div>
  
  <!--</form>-->

  </div>
  </div>
  </div>


  <div v-else class="col">



  <EpsonGiftReceipt  v-if="fiscalPrinter.show" :key="refresh" @close="closeFiscalPrinter()" v-bind:data="fiscalPrinter"></EpsonGiftReceipt>    


  <product-img v-if="img" @close="closeImg()" v-bind:img='img'></product-img> 
   <div class="row">
    <button v-if="items.length>0 || payments.length>0"  @click="items=[],payments=[]" type="button"  class="btn btn-secondary mb-1 btn-block">
    <i style="color:yellow" class="fas fa-reply mr-2"></i>
    RITORNA A PARAMETRI DI RICERCA
  </button> 
   </div> 
   <button v-if="option == 1" :disabled="bt_spinner"  @click="printPDF()"  type="button"  class="btn btn-primary mb-1  mr-2 ">
    <i class="fas fa-print mr-2 "></i>
    STAMPA CHECK LIST
    <span v-if="bt_spinner"  class="spinner-border spinner-border-sm ml-3 text-warning" role="status" aria-hidden="true"></span>
  </button>
  
  <div v-if="option == 1">
  
  <div class="salesList table-responsive">

  <table class="table   table-sm mb-0">
    <thead >
      <tr>
        <th>#</th>
        <th>ID</th>
        <th></th>
        <th>DATA ORA</th>
        <th>PROVENIENZA</th>
        <th>CLIENTE</th>
        <th scope="col">TIPO</th>
        <th><i  class="fas fa-user-tag" aria-hidden="true"></i></th>
        
        <!--<th scope="col">EAN</th>-->
        
        <th scope="col">PRODOTTO</th>
        <th scope="col">COLORE</th>
        <th scope="col">MISURA</th>
        <th class="text-right" scope="col">LISTINO'</th>
        <th class="text-right" scope="col">IMPORTO</th>
        <th class="text-right" scope="col">SCONTO</th>
        <th class="text-right" scope="col">TOTALE</th>
        <th class="text-right" scope="col">ABBUONO</th>
        <th class="text-right" scope="col">PAGATO €</th>
        <th class="text-right" scope="col">
          PAGAMENTO
        </th>
        <th></th>
        
        
      </tr>
    </thead>
    <tbody>
      <tr class="pointer " @dblclick ="getProductImg(item)" 
      :style="{ backgroundColor: item.rowType==2 ? '#FFFFE0':'white', color: setRowColor(item),fontSize: item.rowType == 2 ? '20px':'15px',fontWeight:item.rowType == 2 ? 'bold':'normal' }" v-for="(item, index) in filteredItems" :key="index">
     
      <td  v-if="!item.create_at">
        <small>
            {{item.index}} 
           </small>
      </td>
      <td :style="{borderColor : setRowBorderColor(item)}" v-else>
        
      </td>
        <td  :style="{borderColor : setRowBorderColor(item)}" v-if="item.create_at">
         
            {{ item.saleId }}  
         
          
        </td>
        <td   v-else>

        </td>
        <td :style="{borderColor : setRowBorderColor(item)}">
          <div   class="dropdown" v-if="item.create_at">

                    <button style="color:black;background-color: white;" class="btn btn-info dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false">                        
                        STAMPA
                    </button>
                    <div class="dropdown-menu ">
                    
                    <a class="dropdown-item" @click.stop ="pdfCustomerReceipt(item.saleId)" href="#">
                      <i style="color:brown" class="far fa-file-pdf mr-2" aria-hidden="true"></i>
                        Ricevuta A4                        
                    </a>
                    
                    
                    <a class="dropdown-item" @click.stop ="getDataToPrint(item)" href="#">
                      <i style="color:black" class="fas fa-print mr-2" aria-hidden="true"></i>
                        Ticket cortesia (JSPM)
                    </a>

                    <a class="dropdown-item" @click ="setFiscalPrinter(item)" href="#">
                      <i style="color:blue" class="fas fa-print mr-2" aria-hidden="true"></i>
                        Ticket cortesia (FP)
                    </a>
                    <a class="dropdown-item" @click ="setPromoCouponToPrint(item)" href="#">
                      <i style="color:blueviolet" class="fas fa-print mr-2" aria-hidden="true"></i>
                        Coupon Promo (SDP)
                    </a>

                                          
                    </div>
            </div>




          
        </td>
        <td 
        :style="{borderColor : setRowBorderColor(item)}"
        class="date_time text-nowrap">
        
        <strong> {{item.create_at}} {{item.hour_at}}</strong>
        
        </td>
        <td :style="{
          borderColor : setRowBorderColor(item),
          color:item.soldBy == 'Retail' ? 'black':'#f66c09',fontWeight:item.soldBy == 'Retail' ? 'normal':'bold'}">{{item.soldBy}}</td>
        <td 
        
        class="text-nowrap" :style="{
          borderColor : setRowBorderColor(item),
          color:item.soldBy == 'Retail' ? 'black':'#3bab05',fontWeight:item.soldBy == 'Retail' ? 'normal':'bold'}">{{item.customer}}</td>
        <td
        :style="{borderColor : setRowBorderColor(item)}"
        class="text-nowrap" >
         
          <small v-if="item.rowType == 1" style="color:red" id="reso" class="form-text ">Reso da cliente</small>
          <small v-if="item.rowType == 0" style="color:black" id="vendita" class="form-text ">Vendita</small>
        </td>
         <td
         :style="{borderColor : setRowBorderColor(item)}"
         ><strong>{{item.assistant_code}} </strong></td>
       
        <td 
        :style="{borderColor : setRowBorderColor(item)}"
        class="text-nowrap">{{item.brand}} {{item.sku}} {{item.category}} {{ item.season }} {{ item.season_year }}
          <br>
          <small>{{item.barcode}}</small>
        </td>
        
        <td 
        :style="{borderColor : setRowBorderColor(item)}">{{item.color}}</td>
        <td
        :style="{borderColor : setRowBorderColor(item)}"
        >{{item.size}}</td>
        
        <td :style="{
          
        
          borderColor :  setRowBorderColor(item,1),
          

          color:item.rowType == 1 ? 'red':'black'}" 

          class="text-right">{{fmt1(item.label_price)}}
        </td>

        <td :style="{
          
          borderColor : setRowBorderColor(item,1),
          color:item.original_price != item.price_changed  ? 'red':''}"  class="text-right">{{fmt1(item.price)}}

          
        </td>
        <td :style="{
          
          
          
          borderColor :  setRowBorderColor(item,1),
          color:item.original_discount != item.discount_changed  ? 'red':''}" class="text-right">{{item.discount}}</td>
        <td  
          
          :style="{
        
          
            borderColor :  setRowBorderColor(item,1)}"
          class="text-right">{{fmt1(item.row_total)}}
        </td>
        <td 
        :style="{
          
          
          borderColor :  setRowBorderColor(item,1)}"
        class="text-right">{{fmt1(item.totalDiscount)}}</td>

        <td  :style="{
  
          borderColor :  setRowBorderColor(item,1)}" class="text-right">
           <i v-if="item.rowType==2 && item.round_total > 0 " style='color:red ;font-size: 12px;'  class="mr-2" aria-hidden="true">
            <span>
            (+{{item.round_total}})
            </span>
          </i>
         
          {{fmt1(item.totalPaid)}}

        </td>
        <td :style="{
          
          borderColor : setRowBorderColor(item,1),
          
          color:'blue',fontSize: '15px'} " class="text-right">{{item.paymentType}}</td>
        <td :style="{

          borderColor : setRowBorderColor(item,1),
   
          } "
        > <i v-if="item.printTicket==1" class="fas fa-print" aria-hidden="true"></i></td>
        
      </tr> 
    </tbody>
        <tfoot>
        <tr  class="">  

        
        <th ></th>
        <th ></th>
        <th ></th>
        <th > </th>
        <th > </th>
        <th > </th>
        <th > </th>
        <th ></th>
        <!--
        <th></th>
        -->
        <th ></th>
        <th ></th>       
        
        <th  class="text-nowrap">TOTALE €</th> 
        
         <th  class="text-right">{{fmt1(total.total4)}}</th>
        <th ></th>
        <th ></th>
        <th  class="text-right">{{fmt1(total.total1)}}</th>
        <th  class="text-right">{{fmt1(total.total2)}}</th>
        <th  class="text-right">
          {{fmt1(total.total3)}}</th>
        <th> </th>
        <th> </th>
        </tr>
      
      </tfoot> 
  </table>
  


</div>

<label for="cerca"><strong>
  <i  class="fas fa-filter mr-2" aria-hidden="true"></i>
  Filtra</strong></label>
<input class="form-control" type="text" name="query" v-model="filterKey">





  </div>

  <div v-else>
    
    <ul id="paymentsData">
      
      <li v-for="(item, index) in payments" :key="index">
       {{ item.create_at }} - {{ item.customer }} -  {{ fmt1(item.total) }} - {{ item.typeId }}
      </li>

    </ul>

  </div>  





</div>  


</div>
</div>
</div>



</div>
</template>
<script>
import alertBox           from '@/components/common/AlertBox.vue';
import cassa              from '@/components/common/Desk.vue';

import api                from '@/api'
import { mapGetters }     from 'vuex';
import pdfCustomerReceipt from '@/components/mixins/pdfCustomerReceipt.js'
import CustomerCortesia   from '@/components/mixins/CustomerCortesia.js'
import jsPDF              from 'jspdf';
import pushState          from '@/components/mixins/pushState'
import storeSelect        from '@/components/common/StoreSelect_1.vue'
import productImg         from '@/components/common/ProductImg.vue'
import fmt                from '@/components/mixins/fmt.js'
import EpsonGiftReceipt   from '@/components/rt/EpsonGiftReceiptModal.vue'


export default {
    mixins: [pdfCustomerReceipt,pushState,CustomerCortesia,fmt],
  
  components: {alertBox,cassa,storeSelect,productImg,EpsonGiftReceipt},
  data() {
    return {

       fiscalPrinter  : {},

      salesFrom       : [{'typeId':0,'description': 'RETAIL'},{'typeId':1 ,'description':'ONLINE'}],
      typeId          : 0,
      img             : '',
      store             : 
      {
        Id            : 0,
        isActive      : true,
       
        optionBase    : false,
        required      : false
      },

      filterKey              : '',
      deskId                 : 1,
      create_at_from         : new Date().toISOString().slice(0, 10),
      create_at_to           : new Date().toISOString().slice(0, 10),
      bt_spinner             : false,
     
      msg                    : {
        title                : '',
        body                 : '',
        type                 : 0
      }, 
      items                  : [],
     
      imgData                : '',
      payments               : [],
      option                 : 1,
      pdf_items              : [],
      description1           : '',
      description2           : '',
      description3           : '',
      printed1               : 0,
      printed2               : 1,
      refresh                : 0,
      
      
      
    };
  },
  computed :{
   
    ...mapGetters(['storeId','company','isAdmin']) , 
     filteredItems : function () 
      {
        var filterKey = this.filterKey && this.filterKey.toLowerCase()
        var items = this.items
        if (filterKey) {
        items = items.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })
      }
        return items
     },
    total : function() {
   
      let  total = {
        total1 : 0,total2:0,total3:0,total4:0
      }
      this.items.forEach(item => {
        if(item.rowType==2)
        {
          total.total1 += Number(item.row_total)
          total.total2 += Number(item.totalDiscount)
          total.total3 += Number(item.totalPaid)
          total.total4 += Number(item.label_price)

        }
      })
      return total
    }


  },
  directives: {
    focus: {
      // directive definition
      inserted: function(el) {
        //el.focus();
      }
    }
  },
  mounted: function() {
    //this.getData()


    this.store.Id = this.storeId
    this.store.isActive = this.isAdmin

   


  },
  created: function() {},
  methods: {
   
    setPromoCouponToPrint(item)
    {
      const sp    = {'sp':'spUpdatePromoCouponCustomerPrinted'}
      const data  = {'saleId' : item.saleId}      
      const json  = Object.assign(data, sp)
      
      
      api.post(json).then(res => {
      if(res.status==200)
        {
          
          
         
        }
        else if(res.status == 500)
        {
         
  
        
        } 
        else
        {
  
        
        } 
    }).catch(err => 
    {
      
  
       
    }).finally(() => {
      
    });

  
    },
    getFiscalPrinter()
    {
     
      const sp    = {'sp':'spStoreDeskFiscalPrinter'}
      const data  = {'storeId':this.storeId,'deskId':this.deskId}      
      const json  = Object.assign(data, sp)
      
      return new Promise( (resolve) =>  {
      api.post(json).then(res => {
      if(res.status==200)
        {
          
         if(res.data.recordsets[0].length > 0) 
         {
            resolve(res.data.recordsets[0][0])
                        
         }
         
        }
        else if(res.status == 500)
        {
         
          resolve({})
        
        } 
        else
        {
          resolve({})    
        
        } 
    }).catch(err => 
    {
      
      resolve({})
       
    }).finally(() => {
      
    });

  })

   },
    async setFiscalPrinter(item)
    {

      const data = await this.getFiscalPrinter()
     
      if(data.fpId)
      {
        
        this.fiscalPrinter = data
        this.fiscalPrinter.saleId = item.saleId
        this.fiscalPrinter.show = 1
      
        this.refresh++
      }

    },
    closeFiscalPrinter()
    {
      
      
      this.fiscalPrinter.show = 0
    },
    setRowColor(item)
    {
      

      if(item.rowType == -1)
      {
        return 'white'
      }
      if(item.rowType == 2)
      {
        return '#254117'
      }
      return 'black'
    },

    setRowBorderColor(item,set)
    {
      if(item.row_number == 1)
      {
        return ''
      }
      if(item.rowType == 2 && set)
      {
        return 'green'
      }
    },
   
    getProductImg(item)
    {
     
      if(!item.img)
      {return}

      if(this.company.img_url)
      {
        this.img = this.company.img_url + item.img
        
      }
    },
    closeImg()
    {
      this.img = ''
    },
    setStoreId(storeId)
    {
      this.store.Id = storeId
      //this.title.store = e.target.options[e.target.options.selectedIndex].text  
    },   

   setDesk(deskId)
   {
     
     this.deskId = deskId
   },
   
   formatList()
    {
        var arr = []
        
        var total = 0
        let label_total = 0
        var rowIndex = 0
        
        for (var i = 0; i < this.items.length; i++)   
          {
            var m = 1
            if(this.items[i]['rowType'] == 1)
            {
              m = -1
            }
            total += Number(this.items[i]['row_total']) * m
            label_total +=   Number(this.items[i]['label_price']) * m
            //console.log(Number(this.items[i]['row_total']))
            arr.push(this.items[i])    

            if(this.items[i]['row_number'] == this.items[i]['row_count'])
              {
                rowIndex++
                //console.log('TOTAL',total)  
                
                arr.push({'index' : rowIndex, 'rowType':2,'row_total':total,'totalDiscount':this.items[i]['totalDiscount'],'totalPaid':this.items[i]['totalPaid'],'printTicket':this.items[i]['printTicket'],'paymentType':this.items[i]['paymentType']
                ,'round_total':this.items[i]['round_total'],'label_price': label_total,'Id':this.items[i]['saleId'] 
                
                })

                
                total = 0
                label_total = 0
                
                
              }
           
            
          }

         
          arr.forEach(item=>{
            if(item.rowType != 2 )
            {
              
              item.totalDiscount = 0.00
              item.totalPaid     = ''
              item.printTicket   = 0
              item.paymentType   = ''
              
              // Scarto 1° riga Scontrino per Data e Ora
              if(item.row_number > 1 )
              {
                item.create_at = ''
                item.hour_at = ''
              }
              
            }
          })
          

          this.items = arr
          //console.log(this.total)

    },


    async getSalesList(evt) {
      
      

      this.msg.title = '' 
      this.items = []
      if(!this.create_at_from || !this.create_at_to)
      {
        
        this.msg.title = "ATTENZIONE "
        this.msg.body  = 'Data di vendita non valida.'
        this.msg.type = 1
       
        return
      }

      this.printed1 = 0
      this.printed2 = 1

      if(this.company.Id == 48 )
      {
        this.printed1 = 1
        this.printed2 = 1
        
      }
      if(this.company.Id == 48 && evt.ctrlKey)
      {
        this.printed1 = 0
        this.printed2 = 0
        
      }
      if(this.company.Id == 48 && evt.shiftKey)
      {
        this.printed1 = 0
        this.printed2 = 1
        
      }

  
      const sp    = {'sp':'spDeskSalesList'}    
      const data  = {'storeId':this.store.Id,'create_at_from':this.create_at_from,'create_at_to':this.create_at_to,'deskId':this.deskId,'typeId':this.typeId,'printed1':this.printed1,'printed2':this.printed2}
      const json  = Object.assign(data, sp)

      this.bt_spinner = true
      await api.post(json).then(res => {
      
        if(res.status==200)
          {
            this.items    = res.data.recordsets[0]
            
            this.pdf_items = res.data.recordsets[1]
            this.description1 = this.create_at_from
            this.description2 = this.create_at_to
            this.description3 = this.deskId
           
            if(this.items.length ==0 )
            {
              
              this.msg.title = "ATTENZIONE"
              this.msg.body = 'DATI INESISTENTI.'
              this.msg.type = 1
     
            }
            else
            {
              this.formatList()
            }
         
          }
          else if(res.status==500)
          {
            
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res.data
            this.msg.type  = 1

          } 
          else
          {
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res
            this.msg.type  = 1                  
            

          } 
      }).catch(err => 
      {
          
      this.msg.title = 'ATTENZIONE '
      this.msg.body  = err.message
      this.msg.type  = 1  

      }).finally(() => {
        this.bt_spinner = false
      });

    },

    getPDFData()
    {
      
      
      const sp    = {'sp':'spDeskSalesListCheckList'}
      const data  = {'storeId':this.store.Id,'create_at_from':this.create_at_from,'create_at_to':this.create_at_to,'deskId':this.deskId,'printed1':this.printed1,'printed2':this.printed2}
      const json  = Object.assign(data, sp)

      this.bt_spinner = true

      return new Promise( (resolve) =>  {
      api.post(json).then(res => {
        if(res.status==200)
          {
             const items    = res.data.recordsets[0]
             resolve(items) 
            
            
          }
          else if(res.status==500)
          {
            
            resolve([]) 
            
          } 
          else
          {
            resolve([]) 

          } 
      }).catch(err => 
      {
          
      
      }).finally(() => {
        this.bt_spinner = false
      });

    })
 
    },
    async printPDF()
    {
      this.pdf_items = []
      this.pdf_items = await this.getPDFData()
      if(this.pdf_items.length == 0)
      {
        return
      }
      const doc = new jsPDF()

      this.spinner2 = true  
      var page = 1
      
      var pages = parseInt(this.pdf_items.length / 50) == this.pdf_items.length / 50 ? parseInt(this.pdf_items.length / 50) : parseInt(this.pdf_items.length / 50) + 1
      
      var row_index = 1
      var page_index = 1
      var init_row = 31
      var row = init_row
      var row_header = row -5
      var col = 10
      var col1 = 20
      var col2 = 50
      var col3 = 90
      var col4 = 150
      var col5 = 171
      var total = 0
      //var doc = new jsPDF()

      var header = function(description1,description2,description3)
      {
        var d = new Date();
        var n = d.toLocaleString();
        doc.setFontSize(12)
        doc.text('CHECK LIST ARTICOLI VENDUTI ',  105, 10, null, null, "center");
       // doc.setTextColor(0, 0, 255);
        doc.text('dal ' + description1 + ' al ' + description2,  105, 15, null, null, "center");
        doc.setTextColor(0, 0, 0);
        
        doc.text('CASSA ' + description3,  105, 20, null, null, "center");
        
        doc.setFont("helvetica","bold");
      
        doc.setFontSize(10)
      
        doc.text('BRAND', col1,row_header);
        doc.text('CATEGORIA', col2, row_header);
        doc.text('PRODOTTO', col3, row_header);
        doc.text('COLORE', col4, row_header);
        doc.text('MIS.', col5, row_header);

        doc.text('Q.TA', 200, row_header,null,null,'right');
        doc.setFont("helvetica","normal");

      }
      var footer = function()
      {
        doc.setFontSize(8)
        doc.text('pag. ' + page.toString() + ' / ' + pages.toString(),  105, 290, null, null, "center");
       
      }
      header(this.description1,this.description2,this.description3)
      footer()


      this.pdf_items.forEach(item=>{
        if(item.row_type == 1)
        {
          total += Number(item.qty)
        }
        
        
       
        doc.setFontSize(8)
       
       

        doc.text(row_index.toString(), col, row);
        doc.text(item.brand.toString().substr(0,15), col1, row);
        if(item.sku.length == 0 && item.category.substr(0,10) != 'Tot. Brand')
        {
          
          doc.setFont("helvetica","bold"); 
                   
        }
       
       doc.text(item.category.toString().substr(0,20), col2, row);
       doc.setFont("helvetica","normal"); 
        doc.text(item.sku.toString().substr(0,50), col3, row);
        doc.text(item.color.toString().substr(0,10), col4, row);
        doc.text(item.size.toString().substr(0,5), col5, row);

        doc.text(item.qty.toString(), 200, row,null,null,'right');
        if(item.sku.length == 0 && item.category.substr(0,10) != 'Tot. Brand')
        {
          
          
          doc.rect(col+175, row-3, 19, 4)
          
          //doc.setFontSize(10)
        }


        if(item.category.substr(0,10) == 'Tot. Brand')
        {
          
          
          doc.rect(col+9, row-3, 185, 4)
          
          //doc.setFontSize(10)
        }

        if(page_index == 50 && row_index < this.pdf_items.length)
        {
          page++  
          doc.addPage("a4");
          header(this.description1,this.description2,this.description3)
          footer()
          row = init_row
          row_index++
          page_index = 1
        }
        else
        {
          row = row + 5
          row_index++
          page_index++
        }
        
      })
        doc.setFontSize(10)
        doc.text('TOTALE ' + total ,  200, 285, null, null, "right");
      //doc.save('CheckList_' + Date.now().toString() )
      let fileName = 'CheckList_' + Date.now().toString()
      window.open(doc.output('bloburl', { filename: fileName }), '_blank');
      this.spinner2 = false
    },

    async getPaymentsList(evt) {
      
      

      this.msg.title = '' 
      this.payments = []
      if(!this.create_at_from || !this.create_at_to)
      {
        
        this.msg.title = "ATTENZIONE "
        this.msg.body  = 'Data di vendita non valida.'
        this.msg.type = 1
       
        return
      }
      
      const sp    = {'sp':'spDeskPaymentsList'}
     
      let printed1 = 0
      let printed2 = 1

      if(this.company.Id == 48 )
      {
        printed1 = 1
        printed2 = 1
        
      }
      if(this.company.Id == 48 && evt.ctrlKey)
      {
        printed1 = 0
        printed2 = 0
        
      }
      if(this.company.Id == 48 && evt.shiftKey)
      {
        printed1 = 0
        printed2 = 1
        
      }

      
      const data  = {'storeId':this.storeId,'create_at_from':this.create_at_from,'create_at_to':this.create_at_to,'deskId':this.deskId,'printed1':printed1,'printed2':printed2}
      const json  = Object.assign(data, sp)


      this.bt_spinner = true
      await api.post(json).then(res => {
        if(res.status==200)
          {
            
            this.payments = res.data.recordsets[0]
          
            if(this.payments.length == 0 )
            {
              
              this.msg.title = "ATTENZIONE"
              this.msg.body = 'DATI INESISTENTI.'
              this.msg.type = 1
              return
            }

            
         
          }
          else if(res.status==500)
          {
            
            this.msg.title = 'ATTENZIONE'
            this.msg.body  = res.data
            this.msg.type  = 1

          } 
          else
          {
            this.msg.title = 'ATTENZIONE'
            this.msg.body  = res
            this.msg.type  = 1                  
            

          } 
      }).catch(err => 
      {
          
      this.msg.title = 'ATTENZIONE'
      this.msg.body  = err.message
      this.msg.type  = 1  

      }).finally(() => {
        this.bt_spinner = false
      });

    },


    async getDataToPrint(sale)
    {
      const data = await this.getReceiptPrinterList(sale.storeId,sale.deskId)
      
      if(data.length > 0)
      {
        this.printTicketCortesia(data,sale)
      }
    },


    async getReceiptPrinterList(storeId,deskId)
    {
    
        
        const sp       = {'sp'      : 'spReceiptPrinterList'}
        const data     = {'storeId' : storeId, 'deskId' : deskId} 

        const json     = Object.assign(data, sp)
        return new Promise( async (resolve) =>  {
        await api.post(json).then(res => {
	        if(res.status == 200)
          {
        
            resolve(res.data.recordsets[1])
            

          }
          else if(res.status==500)
          {
    	      
            resolve([])
            

          } 
          else
          {
    	      
            resolve([])
            
          } 
          }).catch(err => 
          {
            
            resolve([])
            console.log(err)
            
          }).finally(() => {
            
          });

        })

    },  









  }
};
</script>
<style scoped>

.salesList {
position  : relative;
height    : 700px;
overflow  : auto;
}


.fa-print
{
  cursor: pointer
}
.pointer:hover
{
  background-color: blue;
  color: white;
  cursor: pointer;
}


.table thead tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : hwb(45 4% 9%);  
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }

 
 

 .table tfoot  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 24px;
    background   : whitesmoke;
    color        : darkgreen;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;
    height       : 50px;
    border-color : green ;
    border-width : 5px;

 } 

.form-check-label
{
  cursor: pointer;
}
h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}
.date_time
{
  font-size: 14px;
}
 .table th:first-child
{
  border-radius : 0 0 0 10px;
}
.table th:last-child
{
  border-radius : 0 10px 0 0;  
}
small{
  font-size: 10px;
}
.card-header
{
  height: 45px;
}

</style>